// Typelizer digest 2ea61fa66650e0255693d9a3afe2c715
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** DELETE /ideaboard/ideas/:idea_id/vote */
  destroy: (
    params: { ideaId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/ideaboard/ideas/:idea_id/vote', params, options),
    method: 'delete',
  }),

  /** POST /ideaboard/ideas/:idea_id/vote */
  create: (
    params: { ideaId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/ideaboard/ideas/:idea_id/vote', params, options),
    method: 'post',
  }),
}
